import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { Mail } from "../assets/images";
import ReCAPTCHA from "react-google-recaptcha";
import { API_URL, RECAPTCHA_KEY } from "../configs/default.config";
const Contact = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [popupMessage, setPopupMessage] = useState<string | null>(null);
    const [captchaToken, setCaptchaToken] = useState<string | null>(null);
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);

    const [formValues, setFormValues] = useState({
        fullName: "",
        email: "",
        message: "",
    })
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        setFormValues((prev) => ({ ...prev, [name]: value }))
    }
    const handleSubmtit = async () => {
        const { fullName, email, message } = formValues;
        if (!fullName || !email || !message) {
            setPopupMessage("Please fill all required fields.");
            return;
        }
        if (!captchaToken) {
            alert("Please complete the CAPTCHA.");
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...formValues,
                    recaptchaToken: captchaToken,
                }),
            });

            if (!response.ok) throw new Error("Failed to send message.");

            setPopupMessage("Your message has been sent successfully!");
            setFormValues({ fullName: "", email: "", message: "", });
            recaptchaRef.current?.reset();
            setCaptchaToken(null);
        } catch (error) {
            setPopupMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full h-full lg:px-10 grid grid-cols-12 pt-[120px] bg-bannerContact bg-cover bg-no-repeat bg-center font-saira">
            {popupMessage && (
                <div className="fixed bottom-10 left-4 bg-[#8AC028] text-white font-bold px-6 py-3 rounded-2xl shadow-lg z-50">
                    {popupMessage}
                    <button className="ml-4 text-sm underline" onClick={() => setPopupMessage(null)}>Close</button>
                </div>
            )}

            <div className="space-y-8 col-span-full">
                <div className="space-y-2 w-full text-center flex items-center justify-center gap-x-2">
                    <p className="max-lg:text-[32px] lg:text-[48px] font-extrabold text-white font-inter">We're Here </p>
                    <div className="max-lg:text-[32px] lg:text-[48px] font-extrabold text-white font-inter px-1 bg-[#8AC028] w-fit">to Help</div>
                </div>
                <div className="w-full grid grid-cols-12 lg:gap-x-[133px] gap-y-8 max-lg:px-4">
                    <div className="space-y-4 lg:col-start-3 lg:col-span-3 max-lg:col-span-full">
                        <div className="space-y-4">
                            <p className="font-inter text-[17px] font-bold text-white">Your Name <span className="text-[14px] text-white px-1 bg-[#8AC028]"> (Required*)</span></p>
                            <input onChange={(e) => { handleChange(e) }} value={formValues.fullName} name="fullName" className="w-full rounded-3xl bg-[#FFFFFF26] backdrop-blur-[27.6] outline-none h-[77px] text-[17px] font-inter font-bold px-4 text-white" />
                        </div>
                        <div className="space-y-4">
                            <p className="font-inter text-[17px] font-bold text-white">Your Email <span className="text-[14px] text-white px-1 bg-[#8AC028]"> (Required*)</span></p>
                            <input onChange={(e) => { handleChange(e) }} value={formValues.email} name="email" className="w-full rounded-3xl bg-[#FFFFFF26] backdrop-blur-[27.6] outline-none h-[77px] text-[17px] font-inter font-bold px-4 text-white" />
                        </div>
                    </div>
                    <div className="lg:col-span-4 max-lg:col-span-full space-y-4">
                        <p className="font-inter text-[17px] font-bold text-white">Message <span className="text-[14px] text-white px-1 bg-[#8AC028]"> (Required*)</span></p>
                        <textarea onChange={(e) => { handleChange(e) }} value={formValues.message} placeholder="Enter your message" name="message" className="text-white w-full lg:min-h-[200px] max-lg:min-h-[100px] rounded-3xl bg-[#FFFFFF26] backdrop-blur-[27.6] outline-none h-[88px] text-[17px] font-inter font-bold p-4 focus:caret-[#8AC028]" />
                    </div>
                    <div className="col-span-full">
                        <div className="lg:hidden block">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={RECAPTCHA_KEY}
                                onChange={(token) => setCaptchaToken(token)}
                                onExpired={() => setCaptchaToken(null)}
                            />
                        </div>
                    </div>
                    <div className="col-span-full space-y-8">
                        <div className="flex items-center justify-center lg:gap-x-20">
                            <div className="lg:block hidden">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={RECAPTCHA_KEY}
                                    onChange={(token) => setCaptchaToken(token)}
                                    onExpired={() => setCaptchaToken(null)}
                                />
                            </div>
                            <div className=" cursor-pointer lg:w-[343px] max-lg:w-full h-14 flex items-center justify-center gap-x-2 bg-[#FFFFFF26] backdrop-blur-[27.6] rounded-3xl bg-[#000000={() => border-l-[1.5px] border-white " onClick={() => { handleSubmtit() }}>
                                <p className="text-[14px] font-inter text-white font-bold">
                                    {loading ? "Sending..." : "Submit"}
                                </p>
                                <img src={Mail} alt="Mail" className="w-[24px] h-[24px]" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="max-lg:flex hidden items-center justify-center px-4 py-2 gap-x-2 bg-[#00000052]">
                    <div className="text-[16px] font-inter text-white font-normal">Copyright</div>
                    <div className="text-[16px] font-inter text-white font-normal">|</div>
                    <div className="text-[16px] font-inter text-white font-normal">Privacy Policy</div>
                    <div className="text-[16px] font-inter text-white font-normal">|</div>
                    <div className="text-[16px] font-inter text-white font-normal">Terms of Service</div>
                </div> */}
            </div>
        </div>
    )
}
export default Contact